import * as React from "react";
import MoreOverlay from "./moreOverlay";
import MultiMedia from "./multiMedia";
import getFirstVideoIndex from "../helper/getFirstVideoIndex";
// styles

const styles = require("./landscapePlaceholder.scss");

interface ILandscapePlaceholderProps {
  summaryData: Array<
    Vingle.CardContent.ImageContentData | Vingle.CardContent.VideoContentData
  >;
  componentWidth: number;
  componentHeight: number;
}

class LandscapePlaceholder extends React.PureComponent<
  ILandscapePlaceholderProps
> {
  public render() {
    const { summaryData } = this.props;
    if (summaryData.length === 1) {
      return this.oneImageContainer();
    } else if (summaryData.length === 2) {
      return this.twoImageContainer();
    } else if (summaryData.length === 3) {
      return this.threeImageContainer();
    } else if (summaryData.length === 4) {
      return this.fourImageContainer();
    } else if (summaryData.length > 4) {
      return this.fourImageContainer(true);
    } else {
      return null;
    }
  }

  private readonly oneImageContainer = () => {
    const data = this.props.summaryData[0];
    const { componentWidth, componentHeight } = this.props;
    const height = Math.min(
      Math.floor(
        (componentWidth * this.props.summaryData[0].height) /
          this.props.summaryData[0].width,
      ),
      componentHeight,
    );
    const style = {
      width: componentWidth,
      height,
    };

    return (
      <div className={`${styles.item} ${styles.typeOne}`} style={style}>
        <MultiMedia
          data={data}
          width={componentWidth}
          height={height}
          autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
        />
      </div>
    );
  };

  private readonly twoImageContainer = () => {
    const { summaryData, componentWidth, componentHeight } = this.props;

    return (
      <div
        className={styles.twoImageWrapper}
        style={{
          width: componentWidth,
          height: componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.marginBottom} ${
            styles.topRight
          } ${styles.topLeft}`}
          style={{
            width: componentWidth,
            height: componentHeight / 2,
          }}
        >
          <MultiMedia
            width={componentWidth}
            height={componentHeight / 2}
            data={summaryData[0]}
            className={`${styles.topRight} ${styles.topLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.item} ${styles.bottomRight} ${
            styles.bottomLeft
          }`}
          style={{
            width: componentWidth,
            height: componentHeight / 2,
          }}
        >
          <MultiMedia
            width={componentWidth}
            height={componentHeight / 2}
            data={summaryData[1]}
            className={`${styles.bottomRight} ${styles.bottomLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
          />
        </div>
      </div>
    );
  };

  private readonly threeImageContainer = () => {
    const { summaryData, componentWidth, componentHeight } = this.props;

    return (
      <div
        className={styles.threeImageWrapper}
        style={{
          width: componentWidth,
          height: componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.top} ${styles.marginBottom} ${
            styles.topRight
          } ${styles.topLeft}`}
          style={{
            width: componentWidth,
            height: componentHeight / 2,
          }}
        >
          <MultiMedia
            width={componentWidth}
            height={componentHeight / 2}
            data={summaryData[0]}
            className={`${styles.topRight} ${styles.topLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.bottom} ${styles.bottomRight} ${
            styles.bottomLeft
          }`}
        >
          <div
            className={`${styles.item} ${styles.bottomLeft}`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[1]}
              className={styles.bottomLeft}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
            />
          </div>
          <div
            className={`${styles.item} ${styles.marginLeft} ${
              styles.bottomRight
            }`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[2]}
              className={styles.bottomRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 2}
            />
          </div>
        </div>
      </div>
    );
  };

  private readonly fourImageContainer = (showMore: boolean = false) => {
    const { summaryData, componentWidth, componentHeight } = this.props;

    return (
      <div
        className={styles.fourImageWrapper}
        style={{
          width: componentWidth,
          height: componentHeight,
        }}
      >
        <div
          className={`${styles.item} ${styles.top} ${styles.marginBottom} ${
            styles.topRight
          } ${styles.topLeft}`}
          style={{
            width: componentWidth,
            height: (componentHeight / 3) * 2,
          }}
        >
          <MultiMedia
            width={componentWidth}
            height={(componentHeight / 3) * 2}
            data={summaryData[0]}
            className={`${styles.topRight} ${styles.topLeft}`}
            autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
          />
        </div>
        <div
          className={`${styles.bottom} ${styles.bottomRight} ${
            styles.bottomLeft
          }`}
        >
          <div
            className={`${styles.item} ${styles.bottomLeft}`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[1]}
              className={styles.bottomLeft}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 1}
            />
          </div>
          <div
            className={`${styles.item} ${styles.marginLeft}`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[2]}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 2}
            />
          </div>
          <div
            className={`${styles.item} ${styles.marginLeft} ${
              styles.bottomRight
            }`}
            style={{
              width: componentWidth / 3,
              height: componentHeight / 3,
            }}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[3]}
              className={styles.bottomRight}
              autoPlay={getFirstVideoIndex(this.props.summaryData) === 3}
              hideBadge={showMore}
            />
            {showMore ? (
              <MoreOverlay
                className={`${styles.more} ${styles.bottomRight}`}
                sizeOfRemain={summaryData.length - 4}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };
}
export default LandscapePlaceholder;
